import styled from '@emotion/styled';
import {
  Button,
  ClickAwayListener,
  Divider,
  IconButton,
  List,
  ListItem,
  Paper,
  Popper,
  Typography,
  useMediaQuery,
  withStyles,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { ClassAttributes, createElement, Fragment, MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Organization from '../../../entity/Organization';
import theme from '../../../theme';
import {
  COLOR_BORDER_PRIMARY,
  COLOR_MENU_BACKGROUND,
  COLOR_MENU_HEADER,
  COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
  COLOR_TEXT_MAIN,
  COLOR_TEXT_SECONDALY,
} from '../../constant/color';
import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = ClassAttributes<HTMLElement> & {
  currentOrganizationId: string | null;
  organizations: Organization[];
  onChangeCurrentOrganization: (organization: Organization) => void;
  isSmartPhone: boolean;
  className?: string;
};

const OrganizationsSelect = ({
  className,
  currentOrganizationId,
  organizations,
  // isSmartPhone,
  onChangeCurrentOrganization,
}: Props) => {
  const [organizationId, setOrganizationId] = useState(currentOrganizationId);
  const accts = organizations.filter(organization => organization.isAccount());
  const orgs = organizations.filter(organization => !organization.isAccount());
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isSmartPhone = useMediaQuery(theme.breakpoints.down('xs'));

  const onClickMenu = (e: MouseEvent<HTMLElement>) => {
    setOpen(true);
    setAnchorEl(e.currentTarget);
  };

  const onRequestClose = () => {
    setOpen(false);
  };

  // TODO: スマホ版のヘッダー部分のmargin修正、selectorのforcus時のデザイン修正
  return (
    <Root className={className} style={!isSmartPhone ? { marginLeft: 12 } : undefined}>
      <SelectButton
        onClick={onClickMenu}
        style={isSmartPhone ? { width: '100%', textTransform: 'none' } : { textTransform: 'none' }}
      >
        <Typography
          style={{
            /* Font */
            fontWeight: 600,
            fontSize: '12px',
            color: COLOR_TEXT_MAIN,
            lineHeight: '100%',
          }}
        >
          {organizations.find(organization => organization.id === currentOrganizationId)?.name}
        </Typography>
        <ArrowDropDownIcon
          style={{
            color: COLOR_TEXT_MAIN,
          }}
        />
      </SelectButton>
      {isSmartPhone ? (
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          transition
          disablePortal
          style={{ marginTop: '-32px', width: '100%', paddingRight: '48px' }}
        >
          <ClickAwayListener onClickAway={onRequestClose}>
            <StyledPaper style={{ width: '100%', backgroundColor: COLOR_MENU_BACKGROUND, borderRadius: 8 }}>
              <Fragment>
                <List
                  style={{
                    padding: 0,
                  }}
                >
                  <ListItem
                    style={{
                      height: 32,
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: 16,
                      paddingRight: 8,
                    }}
                    button
                    onClick={onRequestClose}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        position: 'static',
                        fontSize: 12,
                        fontWeight: 600,
                        color: COLOR_TEXT_MAIN,
                      }}
                    >
                      {organizations.find(organization => organization.id === currentOrganizationId)?.name}
                    </Typography>
                    <ArrowDropUpIcon
                      style={{
                        color: COLOR_TEXT_MAIN,
                      }}
                    />
                  </ListItem>
                </List>
                <DividerArea>
                  <Divider />
                </DividerArea>
                <List
                  style={{
                    padding: 0,
                    maxHeight: 'calc(80vh - 48px)',
                    overflowY: 'auto',
                  }}
                >
                  <List
                    style={{
                      padding: '16px 0px 24px 0px',
                    }}
                  >
                    {accts.length > 0 && orgs.length > 0 ? (
                      <ListItem style={{ padding: '0px 20px' }}>
                        <SubHeader variant="body2" color="textSecondary">
                          <FormattedMessage id="organization_setting.select.account" />
                        </SubHeader>
                      </ListItem>
                    ) : null}
                    {accts.map(organization => (
                      <ListItem
                        style={listItemStyle}
                        button
                        onClick={() => {
                          setOrganizationId(organization.id);
                          const org = organizations.find(_org => _org.id === organization.id);
                          if (org) {
                            onChangeCurrentOrganization(org);
                          }
                          onRequestClose();
                        }}
                        key={organization.id}
                      >
                        <Typography style={typographyStyleForSP}>{organization.name}</Typography>
                        {organization.id === organizationId ? (
                          <CheckIcon style={{ color: COLOR_TEXT_SECONDALY }} />
                        ) : null}
                      </ListItem>
                    ))}
                    {accts.length > 0 && orgs.length > 0 ? (
                      <div>
                        <DividerArea>
                          <Divider />
                        </DividerArea>
                        <ListItem style={{ padding: '0px 20px', marginTop: 16 }}>
                          <SubHeader variant="body2" color="textSecondary">
                            <FormattedMessage id="organization_setting.select.organization" />
                          </SubHeader>
                        </ListItem>
                      </div>
                    ) : null}
                    {orgs.map(organization => (
                      <ListItem
                        style={listItemStyle}
                        button
                        onClick={() => {
                          setOrganizationId(organization.id);
                          const org = organizations.find(_org => _org.id === organization.id);
                          if (org) {
                            onChangeCurrentOrganization(org);
                          }
                          onRequestClose();
                        }}
                        key={organization.id}
                      >
                        <Typography style={typographyStyleForSP}>{organization.name}</Typography>
                        {organization.id === organizationId ? (
                          <CheckIcon style={{ color: COLOR_TEXT_SECONDALY }} />
                        ) : null}
                      </ListItem>
                    ))}
                  </List>
                </List>
              </Fragment>
            </StyledPaper>
          </ClickAwayListener>
        </Popper>
      ) : (
        <Popper open={open} anchorEl={anchorEl} placement="bottom-end" transition disablePortal>
          <ClickAwayListener onClickAway={onRequestClose}>
            <StyledPaper style={{ width: 320, backgroundColor: COLOR_MENU_BACKGROUND }}>
              <Fragment>
                <List
                  style={{
                    padding: 0,
                  }}
                >
                  <ListItem
                    style={{
                      height: 48,
                      display: 'flex',
                      justifyContent: 'space-between',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
                      backgroundColor: COLOR_MENU_HEADER,
                    }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        position: 'static',
                        fontSize: 16,
                        fontWeight: 600,
                        color: COLOR_TEXT_MAIN,
                      }}
                    >
                      <FormattedMessage id="headbar.organization_select.title" />
                    </Typography>
                    <IconButton onClick={onRequestClose} style={{ width: 28, height: 28 }}>
                      <CloseIcon style={{ color: COLOR_TEXT_MAIN, width: 24, height: 24 }} />
                    </IconButton>
                  </ListItem>
                </List>
                <List
                  style={{
                    padding: 0,
                    maxHeight: 'calc(80vh - 48px)',
                    overflowY: 'auto',
                  }}
                >
                  <List
                    style={{
                      padding: '16px 0px 24px 0px',
                    }}
                  >
                    {accts.length > 0 && orgs.length > 0 ? (
                      <ListItem style={{ padding: '0px 20px' }}>
                        <SubHeader variant="body2" color="textSecondary">
                          <FormattedMessage id="organization_setting.select.account" />
                        </SubHeader>
                      </ListItem>
                    ) : null}
                    {accts.map(organization => (
                      <ListItem
                        style={listItemStyle}
                        button
                        onClick={() => {
                          setOrganizationId(organization.id);
                          const org = organizations.find(_org => _org.id === organization.id);
                          if (org) {
                            onChangeCurrentOrganization(org);
                          }
                          onRequestClose();
                        }}
                        key={organization.id}
                      >
                        <Typography style={typographyStyle}>{organization.name}</Typography>
                        {organization.id === organizationId ? (
                          <CheckIcon style={{ color: COLOR_TEXT_SECONDALY }} />
                        ) : null}
                      </ListItem>
                    ))}
                    {accts.length > 0 && orgs.length > 0 ? (
                      <div>
                        <DividerArea>
                          <Divider />
                        </DividerArea>
                        <ListItem style={{ padding: '0px 20px', marginTop: 16 }}>
                          <SubHeader variant="body2" color="textSecondary">
                            <FormattedMessage id="organization_setting.select.organization" />
                          </SubHeader>
                        </ListItem>
                      </div>
                    ) : null}
                    {orgs.map(organization => (
                      <ListItem
                        style={listItemStyle}
                        button
                        onClick={() => {
                          setOrganizationId(organization.id);
                          const org = organizations.find(_org => _org.id === organization.id);
                          if (org) {
                            onChangeCurrentOrganization(org);
                          }
                          onRequestClose();
                        }}
                        key={organization.id}
                      >
                        <Typography style={typographyStyle}>{organization.name}</Typography>
                        {organization.id === organizationId ? (
                          <CheckIcon style={{ color: COLOR_TEXT_SECONDALY }} />
                        ) : null}
                      </ListItem>
                    ))}
                  </List>
                </List>
              </Fragment>
            </StyledPaper>
          </ClickAwayListener>
        </Popper>
      )}
      {/* </FormControl> */}
    </Root>
  );
};

const listItemStyle = {
  height: 48,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0px 20px',
};

const typographyStyle = {
  color: COLOR_TEXT_MAIN,
  fontSize: 14,
  fontWeight: 600,
};

const typographyStyleForSP = {
  color: COLOR_TEXT_MAIN,
  fontSize: 12,
  fontWeight: 600,
};

const Root = styled('div')(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
);

const SelectButton = withStyles({
  root: {
    background: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
    border: `1px solid ${COLOR_BORDER_PRIMARY}`,
    boxSizing: 'border-box',
    borderRadius: '8px',
    height: 32,
    paddingLeft: 16,
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      background: '#F5F6F7',
    },
  },
})(Button);

const StyledPaper = withStyles({
  rounded: {
    borderRadius: 0,
  },
  elevation1: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
  },
  [theme.breakpoints.up('sm')]: {
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50% -50%)',
  },
})(Paper);

const DividerArea = styled('div')({
  padding: `2px ${SPACING_UNIT}px`,
});

const SubHeader = styled(Typography)({
  marginTop: SPACING_UNIT,
}) as typeof Typography;

export default OrganizationsSelect;
